<ion-card (click)="routeToPage()" button>
    <ion-card-header
        color="{{loggableEntity.errorPriority == 'error' ? 'danger' : (loggableEntity.errorPriority == 'information' ? 'primary' : 'warning') }}">
        <ion-card-title>{{ loggableEntity.descriptionKey | translate }}</ion-card-title>
    </ion-card-header>
    <ion-card-content>
        <ion-grid>
            <ion-row class="ion-justify-content-between">
                <ion-col size="8" size-sm="auto">
                    <h6 class="responsive-text">{{ "components.errorCard.tenant" | translate }}:
                        <span class="guid">{{ loggableEntity.tenant.name }}</span>
                    </h6>
                    <p>{{ "components.errorCard.application" | translate }}:
                        <span class="guid">{{ loggableEntity.fullApplicationName }}</span>
                    </p>
                </ion-col>
                <ion-col class="flexContainer" size="4" size-sm="auto">
                    <div>
                        <ion-chip color="dark">
                            {{ chipNumber }}
                        </ion-chip>
                    </div>
                    <ion-text>
                        <small>
                            {{ getErrorTimeMessage(occurredDate) }}
                        </small>
                    </ion-text>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card-content>
</ion-card>
